export enum workloadModes {
  PLAN = 'time_estimate',
  FACT = 'time_spent',
}
